import { BondSortColumns, bondSortColumns } from './type';

export const isBondSortColumnValid = (sortColumn: string | BondSortColumns): sortColumn is BondSortColumns => bondSortColumns.includes(sortColumn as BondSortColumns);
